import localePl from '@angular/common/locales/pl';
import { ActiveFilterListComponent } from './components/filters/active-filter-list/active-filter-list';
import { CdkTableModule } from '@angular/cdk/table';
import { CloseDialogComponent } from './components/form-viewer/close-dialog/close-dialog.component';
import { CommonModule } from '@angular/common';
import { DasherDatePipe } from './pipes/secure/dasher-date.pipe';
import { DasherPipe } from './pipes/secure/dasher.pipe';
import { DataService } from './services/data/data.service';
import { DetailsComponent } from './components/details/details.component';
import { EllipsisPipe } from './pipes/secure/ellipsis.pipe';
import { FileDisplayerComponent } from './components/file-displayer/file-displayer.component';
import { FilterComponent } from './components/filters/filter/filter.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FilterSelectionComponent } from './components/filters/filter-selection/filter-selection.component';
import { FiltersService } from './services/filters/filters.service';
import { FloatingActionButtonComponent } from './components/floating-action-button/floating-action-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormViewerComponent } from './components/form-viewer/form-viewer.component';
import { HttpService } from './services/http/http.service';
import { InfoPopup } from './components/info-popup/info-popup';
import { ListDisplayerComponent } from './components/list-displayer/list-displayer.component';
import { ListRendererComponent } from './components/list/list.component';
import { LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { MapComponent } from './components/map/map.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { OfflineTableFilterService } from './services/filters/offline-table-filter.service';
import { ProcessService } from './services/process/process.service';
import { registerLocaleData } from '@angular/common';
import { RemovalConfirmationDialog } from './components/table/removal-confirmation-dialog/removal-confirmation-dialog.component';
import { ReportService } from './services/report/report.service';
import { SecurePipe } from './pipes/secure/secure.pipe';
import { SellionsFormsModule } from '../../../../../sellions_forms/projects/forms/src/lib/forms.module';
import { SimpleFiltersComponent } from './components/simple-filters/simple-filters.component';
import { SimpleFiltersDialogComponent } from './components/simple-filters/simple-filters-dialog/simple-filters-dialog.component';
import { SimpleFiltersService } from './services/simple-filters/simple-filters.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TableCellComponent } from './components/table/cell/cell.component';
import { TableFilterComponent } from './components/table/filter/table-filter.component';
import { TableRendererComponent } from './components/table/table.component';
import { TableWithFloatingActionButtonComponent } from './components/table-with-floating-action-button/table-with-floating-action-button.component';
import {MatCardModule, MatSnackBar, MatSnackBarModule} from '@angular/material';
import {DataViewListElementMenu} from "./components/data-view-list-element-menu/data-view-list-element-menu";
import {MatMenuModule} from "@angular/material/menu";
import { DataViewDataSource } from './services/data-view-data-source/data-view-data-source.class';
import {ProcessFormService} from "./services/process/process-form.service";
import {TabsComponent} from "./components/tabs/tabs.component";
import {SuperTabsModule} from "ionic2-super-tabs";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptorProvider} from "../../../../../../modules/core/services/auth-interceptor/auth-interceptor";
import {IonicModule} from "ionic-angular/module";

registerLocaleData(localePl);

@NgModule({
  declarations: [
    ListRendererComponent,
    DataViewListElementMenu,
    TableRendererComponent,
    FloatingActionButtonComponent,
    TableWithFloatingActionButtonComponent,
    DetailsComponent,
    FileDisplayerComponent,
    ListDisplayerComponent,
    FiltersComponent,
    FilterSelectionComponent,
    FilterComponent,
    ActiveFilterListComponent,
    RemovalConfirmationDialog,
    SecurePipe,
    EllipsisPipe,
    DasherPipe,
    DasherDatePipe,
    SpinnerComponent,
    TableFilterComponent,
    TableCellComponent,
    InfoPopup,
    SimpleFiltersComponent,
    SimpleFiltersDialogComponent,
    FormViewerComponent,
    CloseDialogComponent,
    MapComponent,
    TabsComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        CdkTableModule,
        MatSortModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        SellionsFormsModule,
        MatSnackBarModule,
        MatIconModule,
        MatMenuModule,
        SuperTabsModule,
        IonicModule
    ],
  exports: [
    ListRendererComponent,
    TableRendererComponent,
    FloatingActionButtonComponent,
    TableWithFloatingActionButtonComponent,
    DetailsComponent,
    FileDisplayerComponent,
    ListDisplayerComponent,
    FiltersComponent,
    FilterSelectionComponent,
    ActiveFilterListComponent,
    SpinnerComponent,
    TableFilterComponent,
    TableCellComponent,
    InfoPopup,
    SimpleFiltersComponent,
    SimpleFiltersDialogComponent,
    DataViewListElementMenu,
    MapComponent,
    TabsComponent
  ],
  providers: [
    DataService,
    FiltersService,
    OfflineTableFilterService,
    ReportService,
    SimpleFiltersService,
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    HttpService,
    ProcessService,
    ProcessFormService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    { provide: 'DataViewDataSource', useClass: DataViewDataSource },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorProvider,
      multi: true,
    },
  ],
  entryComponents: [
    FilterSelectionComponent,
    RemovalConfirmationDialog,
    InfoPopup,
    SimpleFiltersDialogComponent,
    FormViewerComponent,
    CloseDialogComponent,
    MapComponent,
    TabsComponent
  ],
})
export class SellionsLayoutRendererLibModule {
  public static forRoot(environment: any): ModuleWithProviders {
    return {
      ngModule: SellionsLayoutRendererLibModule,
      providers: [
        {
          provide: 'env',
          useValue: environment,
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/sellions-layout-renderer-lib.module.ts